import Vue from "vue";
import {
  Button,
  Steps,
  Icon,
  Tabs,
  Form,
  Input,
  Alert,
  Avatar,
  Select,
  Row,
  Col,
  Table,
  Tooltip,
  Result,
  Popconfirm,
  Modal
} from "ant-design-vue";
Vue.use(Button);
// 步骤条
Vue.component(Steps.name, Steps);
Vue.component(Steps.Step.name, Steps.Step);
// 图标
Vue.component(Icon.name, Icon);
// tab切换
Vue.component(Tabs.name, Tabs);
Vue.component(Tabs.TabContent.name, Tabs.TabContent);
Vue.component(Tabs.TabPane.name, Tabs.TabPane);
// form
Vue.component(Form.name, Form);
Vue.component(Form.Item.name, Form.Item);
// 输入框
Vue.component(Input.name, Input);
Vue.component(Alert.name, Alert);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Table.name, Table);
Vue.component(Tooltip.name, Tooltip);
Vue.component(Result.name, Result);
Vue.component(Popconfirm.name, Popconfirm);

Vue.component(Avatar.name, Avatar);

Vue.component(Modal.name, Modal);

Vue.component(Select.name, Select);
Vue.component(Select.Option.name, Select.Option);
